import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user_details: "",
  language: '',
  
};

const UserDetailStateSlice = createSlice({
  name: 'user_details',
  initialState: initialState,
  reducers: {
    storeUserDetails: (state, action) => {
      state.user_details = action.payload
    },
    removeUserDetails: (state, action) => {
      state.user_details = "";
      state.language = ""
    },
    selectLanguage: (state, action) => {      
      state.language = action.payload;
    },
    
  }
});

export const { storeUserDetails, removeUserDetails, selectLanguage } = UserDetailStateSlice.actions;

export default UserDetailStateSlice.reducer;